mutation UserTemplateCreate($input: UserTemplateCreateInput!) {
  userTemplateCreate(input: $input) {
    clientMutationId
    departmentOccupationTemplate{
      id
    }
   }
}
